export const iconFontAwesomeHouseholdJar = (
	<i className="fa-solid fa-jar"></i>
);
